module.exports = __webpack_public_path__ + "img/promoter.a77149f1.png";